import React from 'react';
import Job from './job';

export default function Jobs({ jobs, doctor, selectedJobId, setSelectedJobId }) {

  if (!jobs) return null;

  return jobs.map(({ id, division, institution, position, cabinet_num }) => (
      <Job
        doctor={doctor}
        key={id}
        id={id}
        division={division}
        institution={institution}
        position={position}
        setSelectedJobId={setSelectedJobId}
        selectedJobId={selectedJobId}
        cabinet_num={cabinet_num}
      />
  ));
}
